import * as AccountNamespace from './account.namespace';
import { urlPath } from './router-map.utils';
import { RouteSegment } from '../interfaces/router-map.interface';

/**
 * The RouterMap module provides a centralized structure for managing and generating URLs for different routes in the app. Which also serves as a registry for routes definition.
 *
 * @namespace RouterMap
 * @example
 * const result = RouterMap.Account.Root -> 'account'
 * // result -> 'mobile'
 * const url = RouterMap.rootUrl(['account', 'mobile'])
 * // url -> /account/mobile
 * const route = RouterMap.buildRoute(['account', 'mobile'])
 * // route -> account/mobile (NOTE: without the leading forward slash)
 */
export namespace RouterMap {
  /** The my-bookings route (old). */
  export const MyBookings: RouteSegment = 'my-bookings';
  /** It contains routes related to user accounts */
  export import Account = AccountNamespace.AccountRouterMap;

  /**
   * Generates the root URL based on the provided route segments.
   * @param routes An array of route segments.
   */
  export const rootUrl = (routes: RouteSegment[]) => urlPath('/', routes);

  /**
   * Generates the route path based on the provided route segments.
   * @param routes An array of route segments.
   *
   * @example
   * const result = RouterMap.buildRoute(['account', 'bookings'])
   * // result -> account/bookings (NOTE: without the leading forward slash)
   */
  export const buildRoute = (routes: RouteSegment[]) => urlPath('', routes);
}
